import { Model, Factory, Response } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../../types.js'
import type { MockServer, MirageServer } from '../server.js'

type TreatmentDocumentData = SchemaAttributes<'TreatmentDocument'>

// Minimal valid PDF (A4 page with "This is a PDF file generated by the mock server.")
const MOCK_PDF_CONTENT =
  'JVBERi0xLjcKCjEgMCBvYmogICUgZW50cnkgcG9pbnQKPDwKICAvVHlwZSAvQ2F0YWxvZwogIC9QYWdlcyAyIDAgUgo+PgplbmRvYmoKCjIgMCBvYmoKPDwKICAvVHlwZSAvUGFnZXMKICAvTWVkaWFCb3ggWyAwIDAgNTk1IDg0MiBdCiAgL0NvdW50IDEKICAvS2lkcyBbIDMgMCBSIF0KPj4KZW5kb2JqCgozIDAgb2JqCjw8CiAgL1R5cGUgL1BhZ2UKICAvUGFyZW50IDIgMCBSCiAgL1Jlc291cmNlcyA8PAogICAgL0ZvbnQgPDwKICAgICAgL0YxIDQgMCBSIAogICAgPj4KICA+PgogIC9Db250ZW50cyA1IDAgUgo+PgplbmRvYmoKCjQgMCBvYmoKPDwKICAvVHlwZSAvRm9udAogIC9TdWJ0eXBlIC9UeXBlMQogIC9CYXNlRm9udCAvSGVsdmV0aWNhLUJvbGQKPj4KZW5kb2JqCgo1IDAgb2JqICAlIHBhZ2UgY29udGVudAo8PAogIC9MZW5ndGggNDQKPj4Kc3RyZWFtCkJUCjE1MCA0MjEgVEQKL0YxIDE0IFRmCihUaGlzIGlzIGEgUERGIGZpbGUgZ2VuZXJhdGVkIGJ5IHRoZSBtb2NrIHNlcnZlcikgVGoKRVQKZW5kc3RyZWFtCmVuZG9iagoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4gCjAwMDAwMDAwNzkgMDAwMDAgbiAKMDAwMDAwMDE3MyAwMDAwMCBuIAowMDAwMDAwMzAxIDAwMDAwIG4gCjAwMDAwMDAzODAgMDAwMDAgbiAKdHJhaWxlcgo8PAogIC9TaXplIDYKICAvUm9vdCAxIDAgUgo+PgpzdGFydHhyZWYKNTI4CiUlRU9G'

export const model = (Model as ModelDefinition<TreatmentDocumentData>).extend(
  {},
)

export const factory = Factory.extend<TreatmentDocumentData>({
  treatment_document_type() {
    return 'ba'
  },
})

function createBase64Document(
  overrides?: Partial<SchemaAttributes<'Base64Document'>>,
): SchemaAttributes<'Base64Document'> {
  return {
    id: '1',
    content: MOCK_PDF_CONTENT,
    content_type: 'application/pdf',
    filename: 'treatment-document.pdf',
    ...overrides,
  }
}

export function routes(server: MockServer) {
  server.get(
    '/consultations/:parent_lookup_consultation/treatment-documents/info',
    function (this: MirageServer, schema) {
      const record = schema.first('treatmentDocument')
      const attributes = (record?.attrs ?? {
        id: '1',
        treatment_document_type: 'ba',
      }) as TreatmentDocumentData

      return {
        data: {
          type: 'TreatmentDocument',
          id: attributes.id,
          attributes,
        },
      }
    },
  )

  server.post(
    '/consultations/:parent_lookup_consultation/treatment-documents/pdf',
    function () {
      const attributes = createBase64Document()
      return {
        data: {
          type: 'Base64Document',
          id: attributes.id,
          attributes,
        },
      }
    },
  )

  server.post(
    '/consultations/:parent_lookup_consultation/treatment-documents/send_as_email',
    function () {
      return new Response(202)
    },
  )
}
